var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":_vm.currentConfig.gutter,"type":_vm.currentConfig.type,"justify":_vm.currentConfig.justify,"align":_vm.currentConfig.align}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }